// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--f2c47";
export var link = "heading-module--link--00ec5";
export var linkCopied = "heading-module--linkCopied--8bd7a";